var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.6667 3.66797C16.6604 3.67907 17.7402 3.76748 18.4445 4.47183C19.25 5.27729 19.25 6.57365 19.25 9.16638V14.6664C19.25 17.2591 19.25 18.5555 18.4445 19.3609C17.6391 20.1664 16.3427 20.1664 13.75 20.1664H8.25C5.65728 20.1664 4.36091 20.1664 3.55546 19.3609C2.75 18.5555 2.75 17.2591 2.75 14.6664V9.16638C2.75 6.57365 2.75 5.27729 3.55546 4.47183C4.25981 3.76748 5.33956 3.67907 7.33333 3.66797",
    stroke: "#121212",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 12.834L15.5833 12.834",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 12.834H6.87508",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 9.625H6.87508",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 16.041H6.87508",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 9.625H15.5833",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 16.041H15.5833",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 3.20898C7.33325 2.44959 7.94886 1.83398 8.70825 1.83398H13.2916C14.051 1.83398 14.6666 2.44959 14.6666 3.20898V4.12565C14.6666 4.88504 14.051 5.50065 13.2916 5.50065H8.70825C7.94886 5.50065 7.33325 4.88504 7.33325 4.12565V3.20898Z",
    stroke: "#121212",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardLine);
export default __webpack_public_path__ + "static/media/clipboard-line.d572c849cd61b34fbd6176cdfb596de1.svg";
export { ForwardRef as ReactComponent };